import { useEffect, useState } from "react";
import client from "@/lib/api";

let cache = null;
const listeners = new Set();

function emit(data) {
  cache = data;
  listeners.forEach((l) => l(data));
}

export async function refreshMeta() {
  const r = await client.get("/meta");
  emit(r.data);
  return r.data;
}

export default function useMeta() {
  const [meta, setMeta] = useState(cache || { cities: [], categories: [] });
  useEffect(() => {
    listeners.add(setMeta);
    if (cache) setMeta(cache);
    else refreshMeta();
    return () => listeners.delete(setMeta);
  }, []);
  return meta;
}
